import { render, staticRenderFns } from "./TrainerCard.vue?vue&type=template&id=df0b66a8&scoped=true"
import script from "./TrainerCard.vue?vue&type=script&lang=js"
export * from "./TrainerCard.vue?vue&type=script&lang=js"
import style0 from "./TrainerCard.vue?vue&type=style&index=0&id=df0b66a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df0b66a8",
  null
  
)

export default component.exports